<template>
  <div>
    <div class="user_body">
      <span class="title">退款单详情</span>
      <span class="order_id">退款单号: {{ orderInfo.order_no }}</span>
      <div class="line"></div>
      <div class="status_bar">
        <div class="status_outer_bar"></div>
        <div class="status_inner_bar">
          <div
            :class="getStepClass(index)"
            v-for="(item, index) in steps"
            :key="index"
          >{{item.title}}</div>
        </div>
      </div>
      <div class="div_lls">
        <div class="dev_list" v-for="(item, index) in steps" :key="index">
          <div class="dev_item1">
            <span></span>
            <span v-if="steps.length != (index+1)"></span>
          </div>
          <div class="dev_item2">
            <div class="dev_item2_view1">{{ item.time ? item.time : '待处理' }}</div>
            <div class="dev_item2_view2">{{ item.title }}</div>
          </div>
        </div>
      </div>
      <template v-if="orderInfo">

        <div class="product_info" v-for="(item, index) in orderGoods" :key="index">
          <img :src="item?.goods?.thumb || '@/assets/user_icon1.png'">
          <span style="flex:2">{{ item.goods?.sku_name || item?.goods?.title }}</span>
          <span style="flex:1">{{ item?.sku?.price || item?.goods?.price }}元</span>
          <span>X{{ item?.sku?.total || item?.goods?.total }}</span>
        </div>
      </template>
      <div class="line"></div>
      <div class="address">
        <span class="add_text2">退款状态：{{ getRefundStatus(refundInfo.status) }}</span>
        <span class="add_text2">退还金额：¥{{ refundInfo.money }}</span>
        <span class="add_text2">申请单号：{{ refundInfo.order_no }}</span>
        <span class="add_text2">订单编号：{{ orderInfo?.order_no }}</span>
        <span class="add_text2">问题描述：{{ refundInfo.content }}</span>
        <span class="add_text2">联系人：{{ orderInfo?.delivery_username }}</span>
        <span class="add_text2">联系电话：{{ refundInfo.mobile }}</span>
        <span class="add_text2" v-if="orderInfo?.delivery_address">收货地址：{{ orderInfo?.delivery_province }} {{ orderInfo?.delivery_city }} {{ orderInfo?.delivery_area }} {{ orderInfo?.delivery_address }}</span>
      </div>
      
      <!-- 退款图片凭证 -->
      <div class="line"></div>
      <div class="image_proofs" v-if="refundInfo.images && refundInfo.images.length > 0">
        <span class="address_1">退款图片</span>
        <div class="image_container">
          <div v-for="(img, index) in refundInfo.images" :key="index" class="image_item">
            <img :src="img" @click="previewImage(img)">
          </div>
        </div>
      </div>
      
      <div class="line"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ServiceInfoView",
  data() {
    return {
      serviceInfo: {},
      orderInfo: null,
      orderGoods: [],
      refundInfo: {},
      steps: [
        {
          title: "提交申请",
          time: "",
          flag: "0"
        },
        {
          title: "平台审核",
          time: "",
          flag: "0"
        },
        {
          title: "已审核",
          time: "",
          flag: "0"
        }
      ]
    };
  },
  created(){
    this.getRefundDetail()
  },
  mounted() {},
  methods: {
    getRefundDetail(){
      this.$api.refundDetail({order_id: this.$route.params.id}).then(res => {
        console.log(res)
        if(res.code == 1){
          // 保存数据
          this.orderInfo = res.data.order || {};
          this.orderGoods = res.data.order_goods || [];
          this.refundInfo = res.data.refund || {};
          this.steps = res.data.steps;
          // // 设置步骤状态
          // if(res.data.steps && res.data.steps.length > 0) {
          //   this.steps = res.data.steps;
          // } else {
          //   // 根据退款状态更新步骤信息
          //   // this.updateStepsFromRefundStatus();
          // }
        } else {
          this.$message.error(res.msg || res.message)
        }
      }).catch(err => {
        console.log(err)
        this.$message.error('获取退款单详情失败')
      })
    },
    
    // 根据退款状态更新步骤信息
    updateStepsFromRefundStatus() {
      // 设置提交申请时间
      if(this.refundInfo.createtime) {
        this.steps[0].time = this.formatTime(this.refundInfo.createtime);
        this.steps[0].flag = "1";
      }
      
      // 如果退款状态为已审核或已退款
      if(this.refundInfo.status == 1) {
        this.steps[1].flag = "1";
        // 如果有审核时间，则显示
        if(this.refundInfo.checktime) {
          this.steps[1].time = this.formatTime(this.refundInfo.checktime);
        }
      }
      
      // 如果退款状态为已退款
      if(this.refundInfo.status == 2) {
        this.steps[1].flag = "1";
        this.steps[2].flag = "1";
        // 如果有退款时间，则显示
        if(this.refundInfo.refundtime) {
          this.steps[2].time = this.formatTime(this.refundInfo.refundtime);
        }
      }
    },
    
    // 获取步骤样式类
    getStepClass(index) {
      if(this.steps[index] && this.steps[index].time) {
        return 'status_inner_bar_div1';
      }
      return 'status_inner_bar_div2';
    },
    
    // 获取退款状态文本
    getRefundStatus(status) {
      switch(parseInt(status)) {
        case -1: return '未提交';
        case 0: return '待审核';
        case 1: return '已通过';
        case 2: return '已驳回';
        default: return '未知状态';
      }
    },
    
    // 格式化时间
    formatTime(timeStr) {
      if(!timeStr) return '';
      
      // 如果是时间戳，转换为日期对象
      let date;
      if(typeof timeStr === 'number') {
        date = new Date(timeStr * 1000);
      } else if(typeof timeStr === 'string') {
        // 如果已经是格式化的时间字符串，直接返回
        if(timeStr.includes('-') && timeStr.includes(':')) {
          return timeStr;
        }
        date = new Date(timeStr);
      } else {
        return '';
      }
      
      // 格式化日期为 MM/DD HH:MM 格式
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      
      return `${month}/${day} ${hours}:${minutes}`;
    },
    
    // 图片预览
    previewImage(url) {
      // 调用Element UI的图片预览
      this.$alert('<div style="text-align:center"><img src="' + url + '" style="max-width:100%"></div>', '', {
        dangerouslyUseHTMLString: true,
        showConfirmButton: false,
        callback: action => {}
      });
    }
  }
};
</script> 

<style lang="less" scoped>
.user_body {
  background: #ffffff;
  padding: 25px;
  display: flex;
  flex-direction: column;
}
.title {
  color: #666666;
  font-size: 16px;
}
.order_id {
  color: #000000;
  font-size: 14px;
  line-height: 20px;
  margin-top: 40px;
}
.line {
  height: 1px;
  background: #f1f1f1;
  margin-top: 15px;
  margin-bottom: 15px;
}
.status {
  color: #999999;
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 16px;
  line-height: 28px;
}
.status_outer_bar {
  height: 20px;
  background: #f1f1f1;
  border-radius: 20px;
  margin-left: 20px;
  margin-right: 20px;
  position: absolute;
}
.status_inner_bar {
  height: 20px;
  margin-left: 20px;
  margin-right: 20px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.status_inner_bar :first-child {
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
}
.status_inner_bar :last-child {
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
}
.status_inner_bar_div1 {
  height: 20px;
  background: #83c44e;
  flex: 1;
  color: #ffffff;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
}
.status_inner_bar_div2 {
  height: 20px;
  background: #f1f1f1;
  flex: 1;
  color: #666666;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
}
.time {
  margin-left: 20px;
  margin-right: 20px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 10px;
}
.time_content1 {
  color: #666666;
  font-size: 12px;
  text-align: center;
  flex: 1;
}
.time_content2 {
  color: #666666;
  font-size: 12px;
  text-align: center;
  flex: 1;
  visibility: hidden;
}
.product_info {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: #000000;
  font-size: 14px;
}
.product_info img {
  width: 80px;
  height: 80px;
  object-fit: cover;
}
.address {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.address_1 {
  color: #000000;
  font-size: 16px;
  margin-top: 10px;
  margin-bottom: 20px;
}
.add_text2 {
  color: #666666;
  font-size: 14px;
  margin-bottom: 10px;
}
.da {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  color: #666666;
  font-size: 14px;
  align-items: center;
}
.prices {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
}
.prices_1 {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-end;
  margin-bottom: 10px;
}
.prices_1 span:nth-child(odd) {
  width: 100px;
  color: #333333;
  font-size: 14px;
  text-align: right;
}
.prices_1 span:nth-child(even) {
  width: 100px;
  color: #3c9c8f;
  font-size: 14px;
  text-align: right;
}
.prices_2 {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-end;
  margin-bottom: 10px;
}
.prices_2 span:nth-child(odd) {
  width: 100px;
  color: #333333;
  font-size: 14px;
  text-align: right;
}
.prices_2 span:nth-child(even) {
  width: 100px;
  color: #3c9c8f;
  font-size: 24px;
  text-align: right;
}
.div_lls {
  border: 1px solid #83c44e;
  padding: 20px;
  margin-top: 10px;
}
.dev_list {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  /* 确保子元素拉伸以填充容器 */
}

.dev_item1 {
  width: 10px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  position: relative;
  height: 50px;
  /* 为伪元素定位做准备 */
}

.dev_item1 span:nth-child(odd) {
  width: 10px;
  height: 10px;
  background-color: #83c44e;
  border: 1px solid #83c44e;
  border-radius: 50%;
  z-index: 9999;
  /* 圆形 */
}

.dev_item1 span:nth-child(even) {
  content: "";
  position: absolute;
  left: 50%;
  top: 10px;
  /* 调整这个值以避开顶部圆点 */
  bottom: -2px;
  width: 1px;
  background-color: #ebebeb;
  transform: translateX(-50%);
}
 
.dev_item2 {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-left: 20px;
}

.dev_item2_view1 {
  color: #777777;
  font-size: 14px;
}

.dev_item2_view2 {
  color: #1a1a1a;
  font-size: 16px;
  margin-top: 5px;
  margin-bottom: 15px;
  white-space: pre-wrap;
  word-break: break-all;
}

.image_proofs {
  margin-top: 10px;
  margin-bottom: 20px;
}

.image_container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
}

.image_item {
  width: 80px;
  height: 80px;
  border: 1px solid #eee;
  overflow: hidden;
  cursor: pointer;
}

.image_item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
  



